module.exports = __webpack_public_path__ + "static/media/fruit-apple-0.423e3b13.png";